import React from 'react';

const MaintenancePage = () => {
  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      textAlign: 'center',
      backgroundColor: '#f4f4f4',
      margin: 0,
      fontFamily: 'Arial, sans-serif',
    },
    heading: {
      fontSize: '2.5rem',
      color: '#333',
    },
    paragraph: {
      fontSize: '1.2rem',
      color: '#555',
    },
    footer: {
      marginTop: '20px',
      fontSize: '1rem',
      color: '#888',
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>We're Under Maintenance</h1>
      <p style={styles.paragraph}>Our website is currently undergoing scheduled maintenance. We'll be back soon!</p>
      <footer style={styles.footer}>Thank you for your patience.</footer>
    </div>
  );
};

export default MaintenancePage;
